// Label field metadata — single source of truth shared by the template
// editor (admin), the live preview and the render payload. Product name
// + site header always print; these are the toggleable/orderable fields.
export const PREP_FIELDS = [
  { key: "prep_date", label: "Prep date" },
  { key: "use_by_date", label: "Use-by" },
  { key: "storage", label: "Storage" },
  { key: "staff_id", label: "Staff ID" },
  { key: "allergens", label: "Allergens (Contains)" },
];

export const RETAIL_FIELDS = [
  { key: "price", label: "Price" },
  { key: "best_before", label: "Best before" },
  { key: "ingredients", label: "Ingredients" },
  { key: "allergens", label: "Allergens" },
  { key: "barcode", label: "Barcode" },
];

export const DEFAULT_PREP_TEMPLATE = PREP_FIELDS.map((f) => f.key);
export const DEFAULT_RETAIL_TEMPLATE = RETAIL_FIELDS.map((f) => f.key);

export const fieldLabel = (kind, key) => {
  const list = kind === "retail" ? RETAIL_FIELDS : PREP_FIELDS;
  return list.find((f) => f.key === key)?.label || key;
};
